<template>
    <div>
    <h2> Throne of Heaven:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg', 'Throne Of Heaven')">Download</a><br/>
    Download Clean Map:
    <a href="https://s3.amazonaws.com/files.d20.io/images/230380441/53ChEAbs8aQgdi8Nmn_Ttg/original.jpg?162457052955" target="_blank">Map</a><br/>
    The Throne of Heaven is the medium difficulty encounter with a CR of 13 on floor 3. It is split arena style, so encounters start at specific triggers such as entering a new area or finishing a previous fight.
    <v-row>
        <v-col>
            <img id="Throne Of Heaven" :src="require('../../../assets/Annotated_Throne_Of_Heaven_Map.png')"  contain width="850px"/>
        </v-col>
        <v-col>
        <h4>Map Details: </h4>
        <ul>
            <li>This encounter takes place in a throne room in heaven. However since this is only a memory of Heaven the usual effects of the plane will not affect the party or any creatures, such as enhanced or impeded magic.</li>
            <li>The area is brightly lit and players can see the whole map</li>
            <li>The ceiling is 60 ft</li>
            <li>Map is 17x48</li>
            <li><b>Color Code:</b></li>
            <ul>
                <li>Player Spawn: Pink</li>
                <li>Treasure: Cyan</li>
                <li>Monster and Monster Spawns: Red</li>
                <li>Areas of Interest: Green</li>
                <li>Terrain of Note: White</li>
            </ul>            
        </ul>
        <br/><br/>

        <h4>Monsters:</h4>
        <ul>
            <li><b>Combat 1 CR 13: </b> </li>
            Combat 1 begins as soon as players enter map
            <ul>
                <li><b>1) Movanic Deva CR 10: </b>Cast either antimagic field or holy aura and charge party</li>
                <li><b>2) Balisse CR 9:</b> Attempts to use Brand of the Impenitent on a party member it views as the biggest threat, and then tries to dispel party's spells</li>
                <li><b>3) 2x Choral CR 6: </b> Attempts to buff and heal its teammates, or use its crowd control affects if needed.</li>
            </ul>            
            <br/>
            <li><b>Combat 2 CR 14: </b> </li>
            Combat 2 begins once players enter within 30 feet of Astral Deva's spawn location, or 3 full rounds after combat 1 ends. 
            <ul>
                <li><b>4) Astral Deva CR 14: </b> Emerges From a beam of light into the air, she casts blade barrier than moves to engage.</li>
            </ul>
            <br/>
            <li><b>Combat 3 CR 15: </b> </li>
            Combat 3 begins once players enter within 30 feet of any of the angel's spawn locations, or 3 full rounds after combat 2 ends
            <ul>
                <li><b>5) 2x Shield Archon CR 10: </b> Appears in a bright light, Attempts to engage in melee as fast as possible.</li>
                <li><b>6) Trumpet Archon CR 14: </b> Appears in a bright light, Enters having already cast divine power. Trumpet archon is aware of the strategies and powers the party has used on this floor already. Spends another round casting any buff it thinks it needs, before engaging in melee.</li>
            </ul>
            <br/>
            <li><b>Combat 4 CR 17: </b> </li>
            Combat 4 begins 3 full round after all monsters from wave 3 are dead. 
            <ul>
                <li><b>The Sunlord CR 15: </b>Appears in a ball of fire in spawn location 3, players within 10 feet of his spawn take 8d6 fire damage reflex save dc 24 for half. Players are moved 20 feet away after. Enters having already cast see invisibility and fire shield.</li>
                <li><b>The Hand of the Inheritor CR 15: </b> Appears in a ball of light in spawn location 4, evil players within 10 feet of his spawn take 12d6 holy damage, neutral players receive half. reflex save dc 24 for half. Players are moved 20 feet away after. Enters having already cast see invisibility and greater magic weapon.</li>                
            </ul>
            <br/>
            <li><b>Combat 5 CR 18: </b> </li>
            Combat 5 begins 5 full rounds after either of the monsters in combat 4 are defeated.
            <ul>
                <li><b>2x Planetar CR 16: </b> Appears in a burst of light at spawnpoint 1 and 2. Enter having already cast righteous might and bear's endurance</li>                
            </ul>
        </ul>
        <br/><br/>

        <h4>Treasure:</h4>
        <ul>
            <li><b>1) E+ Perk 200</b></li>
            <li><b>2) 6-12 Potions 50: </b> Requires a survival or knowledge nature DC 23 to gain.</li>
            <li><b>3) Resurrective 75</b></li>
            <li><b>4) U Enchanted U Typed Weapon 200: </b> Requires DC 28 perception check and a DC 23 disable device to obtain.</li>
            <li><b>5) Resurrective 75</b></li>
            <li><b>6) 2x L+ stats 150: </b> Requires a heal or knowledge religion DC 28 to gain</li>
            <li><b>7) Level Up 200</b></li>
            <li><b>8) Armor Enchantment 100: </b> Players who are lawful good can gain R+ armor enchantment for no additional cost</li>
            <li><b>9) Armor Enchantment 100: </b> Players who are lawful good can gain R+ armor enchantment for no additional cost</li>
            <li><b>10) Resurrective 100</b></li>
            <li><b>11) 4-8 typed potions 75</b></li>
            <li><b>12) Typed Spell/Maneuver 60</b></li>
            <li><b>13) Weapon Enchantment 100: </b>Players who are lawful good can gain R+ weapon enchantment for no additional cost</li>
            <li><b>14) Weapon Enchantment 100: </b>Players who are lawful good can gain R+ weapon enchantment for no additional cost</li>
            <li><b>15) Typed Feat 150</b></li>
            <li><b>16) Resurrective 100</b></li>
            <li><b>17) Utility Perk 100</b></li>
            <li><b>18) 4-8 Potions 50</b></li>
            <li><b>19) Spell/Maneuver 40</b></li>
            <li><b>20) lvl+ Healing Spell 40</b></li>
            <li><b>21) Feat 125</b></li>
            <li><b>S1) Small Gold Pile: </b> Can only be obtained with a DC 33 knowledge religion check. Good characters receive +4, lawful characters gain +4</li>
            <li><b>S2) Small Gold Pile: </b> Can only be obtained with a DC 33 knowledge religion check. Good characters receive +4, lawful characters gain +4</li>
            <li><b>C) 2x Level Up Cursed Chest: </b> If players activate cursed chest it spawns a Gate Archon, and rewards two level ups if it is defeated.</li>
        </ul>
        <br/><br/>

        <h4>Areas of Interest: </h4>
        <ul>
            <li><b>1) Holy Platform: </b> Only creatures who are good can enter the area of the platform, even if below or flying above. Once Wave 3 has been defeated any player can enter, but if player is evil they receive 6d6 holy damage at the end of each of their turns when on the platform.</li>
            <li><b>2) Animated Statues: </b> If an evil creature ends their turn adjacent to a statue it will make a melee touch attack +15, that deals 4d6 holy damage and nauseates them for 1 round no save. Players can make knowledge religion check DC 28 to know the statues purpose, and a DC 33 disable device check or a dispel magic DC 24 to disable.</li>
        </ul>
        <br/><br/>


        <h4>Terrain of Note: </h4>
        <ul>
            <li><b>1) Top Platform: </b> This platform is raised 30 feet in the air, there is no space to move beneath it.</li>
            <li><b>2) First Platform: </b> This platform is raised 15 feet in the air, players can walk underneath it.</li>            
        </ul>
        <br/><br/>
                
        </v-col>
    </v-row>
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>